import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 5.002v.5l-8.13 14.99a1 1 0 0 1 -1.74 0l-8.13 -14.989v-.5c0 -1.659 4.03 -3.003 9 -3.003s9 1.344 9 3.002","key":"svg-0"}]]

/**
 * IconCone2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY29uZS0yIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0yMSA1LjAwMnYuNWwtOC4xMyAxNC45OWExIDEgMCAwIDEgLTEuNzQgMGwtOC4xMyAtMTQuOTg5di0uNWMwIC0xLjY1OSA0LjAzIC0zLjAwMyA5IC0zLjAwM3M5IDEuMzQ0IDkgMy4wMDIiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/cone-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCone2 = createReactComponent('outline', 'cone-2', 'Cone2', __iconNode);

export default IconCone2;